import { render, staticRenderFns } from "./SystemLogo.vue?vue&type=template&id=499bed6e&scoped=true&"
import script from "./SystemLogo.vue?vue&type=script&lang=js&"
export * from "./SystemLogo.vue?vue&type=script&lang=js&"
import style0 from "./SystemLogo.vue?vue&type=style&index=0&id=499bed6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499bed6e",
  null
  
)

export default component.exports